let appMode = "ssr";
export function useConfigAppMode() {
  function setAppMode(mode) {
    appMode = mode;
  }
  return {
    setAppMode,
    appMode
  };
}
